var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPreviewIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.12711 10.389C0.30578 10.6335 4.56294 16.3737 10.0001 16.3737C15.4373 16.3737 19.6946 10.6335 19.8731 10.3893C20.0423 10.1574 20.0423 9.8429 19.8731 9.61103C19.6946 9.36661 15.4373 3.6264 10.0001 3.6264C4.56294 3.6264 0.30578 9.36665 0.12711 9.61083C-0.042345 9.84267 -0.042345 10.1574 0.12711 10.389ZM10.0001 4.94508C14.0051 4.94508 17.4739 8.75497 18.5008 10.0005C17.4753 11.2471 14.0137 15.055 10.0001 15.055C5.99525 15.055 2.52668 11.2458 1.49942 9.99958C2.52493 8.75302 5.98646 4.94508 10.0001 4.94508Z",
    fill: "#030203"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99999 13.9561C12.1813 13.9561 13.9561 12.1813 13.9561 9.99999C13.9561 7.81866 12.1813 6.04393 9.99999 6.04393C7.81866 6.04393 6.04393 7.81866 6.04393 9.99999C6.04393 12.1813 7.81866 13.9561 9.99999 13.9561ZM9.99999 7.36264C11.4543 7.36264 12.6373 8.54573 12.6373 9.99999C12.6373 11.4543 11.4543 12.6373 9.99999 12.6373C8.54573 12.6373 7.36264 11.4543 7.36264 9.99999C7.36264 8.54573 8.54569 7.36264 9.99999 7.36264Z",
    fill: "#030203"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreviewIcon);
export default __webpack_public_path__ + "static/media/preview_icon.3c1a8e2f7fffddbce721c20e94440545.svg";
export { ForwardRef as ReactComponent };